export const TIMEOUT_SECOND = 11;
export const MESSAGE_CLOSE_SEC = 10;
